import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditValue from "../../components/values/FormAddEditValue";
import { useGetValueItem } from "../../hooks/values/useGetValueItem";
import LoadingPage from "../../components/global/LoadingPage";

const EditValue = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, item } = useGetValueItem(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/values");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditValue
                isEdit={true}
                currentData={item}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditValue;
